import './lib/firebase';
import { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AuthGate } from './components/AuthGate';
import { AppLoadingScreen } from './components/AppLoadingScreen';
import DynamicLocaleProvider from './context/DynamicLocaleProvider';
import { ThemeProvider } from './context/ThemeProvider';
import { UserProvider } from './context/UserContext';
import { pingBackend } from './lib/pingBackend';

const PitchDeckEvaluatorPage = lazy(() => import('./pages/PitchDeckEvaluatorPage'));

// Public, unauthenticated lead-gen routes that bypass the auth gate entirely.
const PUBLIC_ROUTES = new Set(['/pitch-deck-evaluator', '/evaluate']);

function AppRouter() {
  const location = useLocation();

  if (PUBLIC_ROUTES.has(location.pathname)) {
    return (
      <Suspense fallback={<AppLoadingScreen variant="auth" />}>
        <PitchDeckEvaluatorPage />
      </Suspense>
    );
  }

  return <AuthGate />;
}

export default function App() {
  useEffect(() => {
    pingBackend()
      .then((response) => {
        console.info('[perfina] backend ping:', response);
      })
      .catch((error) => {
        console.warn('[perfina] backend ping failed:', error);
      });
  }, []);

  return (
    <UserProvider>
      <DynamicLocaleProvider>
        <ThemeProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </ThemeProvider>
      </DynamicLocaleProvider>
    </UserProvider>
  );
}
